module.exports = __webpack_public_path__ + "static/media/introduce_base3.26ad721d.png";